(function () {
  const initChalkboardPanorama = () => {
    const sections = document.querySelectorAll('.chalkboard-panorama');
    
    sections.forEach((section) => {
      if (section.classList.contains('chalkboard-initialized')) return;
      section.classList.add('chalkboard-initialized');
      
      const track = section.querySelector('.chalkboard-panorama__track');
      const imagesContainer = section.querySelector('.chalkboard-panorama__images');
      const images = section.querySelectorAll('.chalkboard-panorama__image');
      const hotspotsContainer = section.querySelector('.chalkboard-panorama__hotspots');
      const scrollHint = section.querySelector('.chalkboard-panorama__scroll-hint');
      const progressBar = section.querySelector('.chalkboard-panorama__progress-bar');
      const popup = section.querySelector('.chalkboard-panorama__popup');
      const fullscreen = section.dataset.fullscreen === 'true';
      
      if (!track || !imagesContainer || images.length === 0) return;
      
      let isDragging = false;
      let startX = 0;
      let currentX = 0;
      let scrollLeft = 0;
      let velocity = 0;
      let animationFrame = null;
      let lastTime = 0;
      let lastX = 0;
      let hasInteracted = false;
      
      // Enable fullscreen mode if configured
      if (fullscreen) {
        document.body.classList.add('chalkboard-fullscreen');
      }
      
      // Wait for images to load to get dimensions
      const setupDimensions = () => {
        const sectionHeight = section.offsetHeight;
        let totalWidth = 0;
        
        // Calculate total width of all images scaled to viewport height
        images.forEach((img) => {
          if (img.naturalWidth && img.naturalHeight) {
            const scaledWidth = img.naturalWidth * (sectionHeight / img.naturalHeight);
            totalWidth += scaledWidth;
          }
        });
        
        // If no images, check for background panels or use aspect ratio
        if (totalWidth === 0) {
          const bgPanels = track.querySelectorAll('.chalkboard-panorama__bg-panel');
          if (bgPanels.length > 0) {
            // Each panel is 3:1 aspect ratio
            totalWidth = bgPanels.length * (sectionHeight * 3);
          } else {
            const aspectRatio = parseFloat(section.dataset.aspectRatio) || 12;
            totalWidth = sectionHeight * aspectRatio;
          }
        }
        
        const viewportWidth = section.offsetWidth;
        const maxScroll = Math.max(0, totalWidth - viewportWidth);
        
        // Position hotspots based on total image width
        if (hotspotsContainer) {
          hotspotsContainer.style.width = `${totalWidth}px`;
          hotspotsContainer.style.height = `${sectionHeight}px`;
          
          const hotspots = hotspotsContainer.querySelectorAll('.chalkboard-panorama__hotspot');
          hotspots.forEach((hotspot) => {
            const xPercent = parseFloat(hotspot.dataset.x) || 0;
            const yPercent = parseFloat(hotspot.dataset.y) || 0;
            hotspot.style.left = `${xPercent}%`;
            hotspot.style.top = `${yPercent}%`;
          });
        }
        
        const linkRegions = section.querySelectorAll('.chalkboard-panorama__link-region');
        linkRegions.forEach((region) => {
          region._xMin = parseFloat(region.dataset.xMin) || 0;
          region._xMax = parseFloat(region.dataset.xMax) || 0;
          region._yMin = parseFloat(region.dataset.yMin) || 0;
          region._yMax = parseFloat(region.dataset.yMax) || 0;
          region.style.top = `${(region._yMin / 100) * sectionHeight}px`;
          region.style.height = `${((region._yMax - region._yMin) / 100) * sectionHeight}px`;
        });
        
        const drawings = section.querySelectorAll('.chalkboard-panorama__drawing');
        drawings.forEach((drawing) => {
          drawing._x = parseFloat(drawing.dataset.x) || 0;
          drawing._y = parseFloat(drawing.dataset.y) || 0;
          drawing._height = parseFloat(drawing.dataset.height) || 20;
          const heightPx = (drawing._height / 100) * sectionHeight;
          drawing.style.height = `${heightPx}px`;
          drawing.style.top = `${(drawing._y / 100) * sectionHeight}px`;
        });
        
        // Setup matcha elements positioning
        if (matchaMask) {
          matchaMask._x = parseFloat(matchaMask.dataset.x) || 84;
          matchaMask._y = parseFloat(matchaMask.dataset.y) || 90;
          matchaMask._height = parseFloat(matchaMask.dataset.height) || 100;
          const maskHeightPx = (matchaMask._height / 100) * sectionHeight;
          matchaMask.style.height = `${maskHeightPx}px`;
          matchaMask.style.top = `${(matchaMask._y / 100) * sectionHeight}px`;
        }
        if (matchaButton) {
          matchaButton._x = parseFloat(matchaButton.dataset.x) || 97.45;
          matchaButton._y = parseFloat(matchaButton.dataset.y) || 60;
          matchaButton.style.top = `${(matchaButton._y / 100) * sectionHeight}px`;
        }
        
        // Setup krabs positioning
        if (krabsImg) {
          krabsImg._x = parseFloat(krabsImg.dataset.x) || 17.8;
          krabsImg._y = parseFloat(krabsImg.dataset.y) || 100;
          krabsImg._height = parseFloat(krabsImg.dataset.height) || 35;
          const krabsHeightPx = (krabsImg._height / 100) * sectionHeight;
          krabsImg.style.height = `${krabsHeightPx}px`;
        }

        // Setup xray elements positioning
        if (xrayElements) {
          xrayElements._x = parseFloat(xrayElements.dataset.x) || 72.11;
        }

        // Setup scroll wrap positioning
        if (scrollWrap) {
          scrollWrap._x = parseFloat(scrollWrap.dataset.x) || 88.33;
        }

        // Setup bar modal positioning
        if (barModal) {
          barModal._x = parseFloat(barModal.dataset.x) || 65.5;
        }

        return { imageWidth: totalWidth, viewportWidth, maxScroll };
      };
      
      let dimensions = { imageWidth: 0, viewportWidth: 0, maxScroll: 0 };
      
      const updateDimensions = () => {
        dimensions = setupDimensions();
        // Clamp current scroll position
        currentX = Math.max(-dimensions.maxScroll, Math.min(0, currentX));
        track.style.transform = `translateX(${currentX}px)`;
        updateProgress();
        updateLinkRegions();
        updateDrawings();
        updateMatchaElements();
        updateKrabsElement();
        updateXrayElements();
        updateScrollWrap();
        updateBarModal();
        updateTooltips();
      };
      
      const updateLinkRegions = () => {
        const linkRegions = section.querySelectorAll('.chalkboard-panorama__link-region');
        linkRegions.forEach((region) => {
          const leftInTrack = (region._xMin / 100) * dimensions.imageWidth;
          const widthPx = ((region._xMax - region._xMin) / 100) * dimensions.imageWidth;
          const visibleLeft = leftInTrack + currentX;
          region.style.left = `${visibleLeft}px`;
          region.style.width = `${widthPx}px`;
          region.style.display = (visibleLeft + widthPx > 0 && visibleLeft < dimensions.viewportWidth) ? 'block' : 'none';
        });
      };
      
      const updateDrawings = () => {
        const drawings = section.querySelectorAll('.chalkboard-panorama__drawing');
        drawings.forEach((drawing) => {
          const leftInTrack = (drawing._x / 100) * dimensions.imageWidth;
          const visibleLeft = leftInTrack + currentX;
          drawing.style.left = `${visibleLeft}px`;
        });
      };
      
      const updateMatchaElements = () => {
        if (matchaMask && matchaMask._x !== undefined) {
          const maskLeftInTrack = (matchaMask._x / 100) * dimensions.imageWidth;
          const maskVisibleLeft = maskLeftInTrack + currentX;
          matchaMask.style.left = `${maskVisibleLeft}px`;
        }
        if (matchaButton && matchaButton._x !== undefined) {
          const btnLeftInTrack = (matchaButton._x / 100) * dimensions.imageWidth;
          const btnVisibleLeft = btnLeftInTrack + currentX;
          matchaButton.style.left = `${btnVisibleLeft}px`;
        }
      };
      
      const updateKrabsElement = () => {
        if (krabsImg && krabsImg._x !== undefined) {
          const krabsLeftInTrack = (krabsImg._x / 100) * dimensions.imageWidth;
          const krabsVisibleLeft = krabsLeftInTrack + currentX;
          krabsImg.style.left = `${krabsVisibleLeft}px`;
        }
      };

      const updateXrayElements = () => {
        if (xrayElements && xrayElements._x !== undefined) {
          const xrayLeftInTrack = (xrayElements._x / 100) * dimensions.imageWidth;
          const xrayVisibleLeft = xrayLeftInTrack + currentX;
          xrayElements.style.left = `${xrayVisibleLeft}px`;
        }
      };

      const updateScrollWrap = () => {
        if (scrollWrap && scrollWrap._x !== undefined) {
          const leftInTrack = (scrollWrap._x / 100) * dimensions.imageWidth;
          scrollWrap.style.left = `${leftInTrack + currentX}px`;
        }
      };

      const updateBarModal = () => {
        if (barModal && barModal._x !== undefined) {
          const leftInTrack = (barModal._x / 100) * dimensions.imageWidth;
          barModal.style.left = `${leftInTrack + currentX}px`;
        }
      };

      const updateProgress = () => {
        if (!progressBar || dimensions.maxScroll === 0) return;
        const progress = Math.abs(currentX) / dimensions.maxScroll * 100;
        progressBar.style.width = `${progress}%`;
      };
      
      const hideScrollHint = () => {
        if (scrollHint && !hasInteracted) {
          hasInteracted = true;
          scrollHint.classList.add('is-hidden');
        }
      };
      
      // Mouse events
      const onMouseDown = (e) => {
        if (e.target.closest('.chalkboard-panorama__hotspot') || e.target.closest('.chalkboard-panorama__link-region')) return;
        
        isDragging = true;
        section.classList.add('is-grabbing');
        startX = e.pageX;
        scrollLeft = currentX;
        velocity = 0;
        lastX = e.pageX;
        lastTime = Date.now();
        
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
        
        hideScrollHint();
        e.preventDefault();
      };
      
      const onMouseMove = (e) => {
        if (!isDragging) return;
        
        const x = e.pageX;
        const walk = x - startX;
        const newX = scrollLeft + walk;
        
        // Calculate velocity for momentum
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) {
          velocity = (x - lastX) / dt * 16; // Normalize to ~60fps
        }
        lastX = x;
        lastTime = now;
        
        // Clamp position
        currentX = Math.max(-dimensions.maxScroll, Math.min(0, newX));
        track.style.transform = `translateX(${currentX}px)`;
        updateProgress();
        updateLinkRegions();
        updateDrawings();
        updateMatchaElements();
        updateKrabsElement();
        updateXrayElements();
        updateScrollWrap();
        updateBarModal();

        e.preventDefault();
      };
      
      const onMouseUp = () => {
        if (!isDragging) return;
        
        isDragging = false;
        section.classList.remove('is-grabbing');
        
        // Apply momentum
        if (Math.abs(velocity) > 0.5) {
          applyMomentum();
        }
      };
      
      // Touch events
      const onTouchStart = (e) => {
        if (e.target.closest('.chalkboard-panorama__hotspot') || e.target.closest('.chalkboard-panorama__link-region')) return;
        
        isDragging = true;
        startX = e.touches[0].pageX;
        scrollLeft = currentX;
        velocity = 0;
        lastX = e.touches[0].pageX;
        lastTime = Date.now();
        
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
          animationFrame = null;
        }
        
        hideScrollHint();
      };
      
      const onTouchMove = (e) => {
        if (!isDragging) return;
        
        const x = e.touches[0].pageX;
        const walk = x - startX;
        const newX = scrollLeft + walk;
        
        // Calculate velocity
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) {
          velocity = (x - lastX) / dt * 16;
        }
        lastX = x;
        lastTime = now;
        
        currentX = Math.max(-dimensions.maxScroll, Math.min(0, newX));
        track.style.transform = `translateX(${currentX}px)`;
        updateProgress();
        updateLinkRegions();
        updateDrawings();
        updateMatchaElements();
        updateKrabsElement();
        updateXrayElements();
        updateScrollWrap();
        updateBarModal();
      };

      const onTouchEnd = () => {
        if (!isDragging) return;
        
        isDragging = false;
        
        if (Math.abs(velocity) > 0.5) {
          applyMomentum();
        }
      };
      
      // Wheel scrolling
      const onWheel = (e) => {
        // Allow horizontal scroll with mouse wheel
        const delta = e.deltaX || e.deltaY;
        const newX = currentX - delta;
        
        currentX = Math.max(-dimensions.maxScroll, Math.min(0, newX));
        track.style.transform = `translateX(${currentX}px)`;
        updateProgress();
        updateLinkRegions();
        updateDrawings();
        updateMatchaElements();
        updateKrabsElement();
        updateXrayElements();
        updateScrollWrap();
        updateBarModal();

        hideScrollHint();
        e.preventDefault();
      };
      
      // Momentum animation
      const applyMomentum = () => {
        const friction = 0.95;
        
        const animate = () => {
          velocity *= friction;
          
          if (Math.abs(velocity) < 0.1) {
            velocity = 0;
            animationFrame = null;
            return;
          }
          
          const newX = currentX + velocity;
          currentX = Math.max(-dimensions.maxScroll, Math.min(0, newX));
          track.style.transform = `translateX(${currentX}px)`;
          updateProgress();
          updateLinkRegions();
          updateDrawings();
          updateMatchaElements();
          updateKrabsElement();
          updateXrayElements();
          updateScrollWrap();
          updateBarModal();

          // Stop at edges
          if (currentX === 0 || currentX === -dimensions.maxScroll) {
            velocity = 0;
            animationFrame = null;
            return;
          }
          
          animationFrame = requestAnimationFrame(animate);
        };
        
        animationFrame = requestAnimationFrame(animate);
      };
      
      // Hotspot interactions
      const setupHotspots = () => {
        const hotspots = section.querySelectorAll('.chalkboard-panorama__hotspot');
        
        hotspots.forEach((hotspot) => {
          hotspot.addEventListener('click', (e) => {
            e.stopPropagation();
            
            const action = hotspot.dataset.action || 'popup';
            const link = hotspot.dataset.link;
            const popupId = hotspot.dataset.popupId;
            
            if (action === 'link' && link) {
              window.location.href = link;
              return;
            }
            
            if (action === 'popup' && popup) {
              showPopup(hotspot);
            }
          });
        });
      };
      
      // Popup functionality
      const showPopup = (hotspot) => {
        if (!popup) return;
        
        const title = hotspot.dataset.title || '';
        const description = hotspot.dataset.description || '';
        const image = hotspot.dataset.image || '';
        const link = hotspot.dataset.link || '';
        const linkText = hotspot.dataset.linkText || 'Learn more';
        
        const popupTitle = popup.querySelector('.chalkboard-panorama__popup-title');
        const popupDescription = popup.querySelector('.chalkboard-panorama__popup-description');
        const popupImage = popup.querySelector('.chalkboard-panorama__popup-image');
        const popupLink = popup.querySelector('.chalkboard-panorama__popup-link');
        
        if (popupTitle) popupTitle.textContent = title;
        if (popupDescription) popupDescription.textContent = description;
        
        if (popupImage) {
          if (image) {
            popupImage.src = image;
            popupImage.style.display = 'block';
          } else {
            popupImage.style.display = 'none';
          }
        }
        
        if (popupLink) {
          if (link) {
            popupLink.href = link;
            popupLink.querySelector('span').textContent = linkText;
            popupLink.style.display = 'inline-flex';
          } else {
            popupLink.style.display = 'none';
          }
        }
        
        popup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      };
      
      const closePopup = () => {
        if (!popup) return;
        popup.classList.remove('is-active');
        document.body.style.overflow = '';
      };
      
      // Video popup functionality
      const videoPopup = section.querySelector('.chalkboard-panorama__video-popup');
      
      const showVideoPopup = (region) => {
        if (!videoPopup) return;
        
        const videoId = region.dataset.videoId || '';
        const tvFrame = region.dataset.tvFrame || '';
        
        const tvImg = videoPopup.querySelector('.chalkboard-panorama__video-popup-tv');
        const iframe = videoPopup.querySelector('.chalkboard-panorama__video-popup-iframe');
        
        if (tvImg && tvFrame) {
          tvImg.src = tvFrame;
        }
        
        if (iframe && videoId) {
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        }
        
        videoPopup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      };
      
      const closeVideoPopup = () => {
        if (!videoPopup) return;
        const iframe = videoPopup.querySelector('.chalkboard-panorama__video-popup-iframe');
        if (iframe) iframe.src = '';
        videoPopup.classList.remove('is-active');
        document.body.style.overflow = '';
      };
      
      const showVideoPopupFromDrawing = (videoId, startTime, endTime, tvFrame) => {
        if (!videoPopup) return;
        
        const iframe = videoPopup.querySelector('.chalkboard-panorama__video-popup-iframe');
        const tvImg = videoPopup.querySelector('.chalkboard-panorama__video-popup-tv');
        
        if (iframe) {
          let videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&start=${startTime}`;
          if (endTime) {
            videoUrl += `&end=${endTime}`;
          }
          iframe.src = videoUrl;
        }
        
        if (tvImg && tvFrame) {
          tvImg.src = tvFrame;
        }
        
        videoPopup.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      };
      
      const setupVideoPopup = () => {
        if (!videoPopup) return;
        
        const overlay = videoPopup.querySelector('.chalkboard-panorama__video-popup-overlay');
        const closeBtn = videoPopup.querySelector('.chalkboard-panorama__video-popup-close');
        
        if (overlay) overlay.addEventListener('click', closeVideoPopup);
        if (closeBtn) closeBtn.addEventListener('click', closeVideoPopup);
        
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && videoPopup.classList.contains('is-active')) {
            closeVideoPopup();
          }
        });
      };
      
      // Setup link region clicks
      const setupLinkRegions = () => {
        const linkRegions = section.querySelectorAll('.chalkboard-panorama__link-region');
        linkRegions.forEach((region) => {
          region.addEventListener('click', (e) => {
            const action = region.dataset.action || 'link';
            if (action === 'video') {
              e.preventDefault();
              showVideoPopup(region);
            }
          });
        });
      };
      
      // Iframe modal functionality
      const iframeModal = section.querySelector('.chalkboard-panorama__iframe-modal');
      
      const showIframeModal = (url) => {
        if (!iframeModal) return;
        
        const iframe = iframeModal.querySelector('.chalkboard-panorama__iframe-modal-frame');
        if (iframe) {
          iframe.src = url;
        }
        
        iframeModal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      };
      
      const closeIframeModal = () => {
        if (!iframeModal) return;
        
        const iframe = iframeModal.querySelector('.chalkboard-panorama__iframe-modal-frame');
        if (iframe) iframe.src = '';
        
        iframeModal.classList.remove('is-active');
        document.body.style.overflow = '';
      };
      
      const setupIframeModal = () => {
        if (!iframeModal) return;
        
        const overlay = iframeModal.querySelector('.chalkboard-panorama__iframe-modal-overlay');
        const closeBtn = iframeModal.querySelector('.chalkboard-panorama__iframe-modal-close');
        
        if (overlay) overlay.addEventListener('click', closeIframeModal);
        if (closeBtn) closeBtn.addEventListener('click', closeIframeModal);
        
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && iframeModal.classList.contains('is-active')) {
            closeIframeModal();
          }
        });
      };
      
      // Tooltip functionality
      let activeTooltips = [];
      
      const closeTooltip = (drawing, tooltip) => {
        tooltip.classList.remove('is-visible');
        setTimeout(() => {
          tooltip.remove();
          drawing._tooltipActive = false;
          drawing._tooltip = null;
        }, 550);
        activeTooltips = activeTooltips.filter(t => t.tooltip !== tooltip);
      };
      
      const showTooltip = (drawing, text, heightMultiplier) => {
        const tooltip = document.createElement('div');
        tooltip.className = 'chalkboard-panorama__tooltip';
        tooltip.textContent = text;
        
        tooltip.addEventListener('click', (e) => {
          e.stopPropagation();
          closeTooltip(drawing, tooltip);
        });
        
        drawing.appendChild(tooltip);
        
        requestAnimationFrame(() => {
          tooltip.classList.add('is-visible');
        });
        
        drawing._tooltipActive = true;
        drawing._tooltip = tooltip;
        activeTooltips.push({ drawing, tooltip });
      };
      
      const updateTooltips = () => {
        activeTooltips = activeTooltips.filter(({ drawing, tooltip }) => {
          const drawingRect = drawing.getBoundingClientRect();
          const sectionRect = section.getBoundingClientRect();
          
          const isOffScreen = drawingRect.right < sectionRect.left || drawingRect.left > sectionRect.right;
          
          if (isOffScreen) {
            tooltip.classList.remove('is-visible');
            setTimeout(() => {
              tooltip.remove();
              drawing._tooltipActive = false;
              drawing._tooltip = null;
            }, 550);
            return false;
          }
          
          return true;
        });
      };
      
      // Setup clickable drawings (swing interaction)
      let activeSwungDrawing = null;
      
      // Surf animation state
      let activeSurfDrawing = null;
      let surfAudio = null;
      let surfAnimationFrame = null;
      let surfTimeout = null;
      
      // Matcha Man state
      let matchaActive = false;
      let matchaAudio = null;
      const matchaElements = section.querySelector('.chalkboard-panorama__matcha-elements');
      const matchaMask = section.querySelector('.chalkboard-panorama__matcha-mask');
      const matchaButton = section.querySelector('.chalkboard-panorama__matcha-button');
      
      // Audio clip state — blocks new clips while one is playing
      let activeAudio = null;

      // Krabs popup state
      let krabsActive = false;
      let krabsTimeout = null;
      const krabsImg = section.querySelector('.chalkboard-panorama__krabs-img');

      const showKrabs = () => {
        if (krabsActive || !krabsImg) return;

        krabsActive = true;
        krabsImg.classList.add('is-active');

        krabsTimeout = setTimeout(() => {
          krabsImg.classList.remove('is-active');
          krabsActive = false;
        }, 1500);
      };

      // X-Ray machine state
      let xrayActive = false;
      let xrayAnimFrame = null;
      const xrayElements = section.querySelector('.chalkboard-panorama__xray-elements');

      // Approximate CSS cubic-bezier(0.4, 0, 0.2, 1)
      const xrayEase = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

      // Animate both the machine and the fish with rAF so that at every frame:
      //   fish.translateY = C − machine.translateY
      // This keeps the fish at a fixed Y in the section regardless of machine speed.
      const animateXray = (toActive) => {
        if (xrayAnimFrame) {
          cancelAnimationFrame(xrayAnimFrame);
          xrayAnimFrame = null;
        }
        if (!xrayElements) return;

        const wrapper   = xrayElements.querySelector('.chalkboard-panorama__xray-machine-wrapper');
        const screenClip = xrayElements.querySelector('.chalkboard-panorama__xray-screen-clip');
        const fishImg   = xrayElements.querySelector('.chalkboard-panorama__fish-xray-img');

        // Kill CSS transitions — JS owns transforms from here
        wrapper.style.transition = 'none';
        fishImg.style.transition  = 'none';

        const sectionH  = section.offsetHeight;
        const wrapperH  = wrapper.offsetHeight || sectionH * 0.8;

        // Machine's CSS `top` in px (getComputedStyle resolves % → px)
        const machineTopPx   = parseFloat(getComputedStyle(wrapper).top) || 0;
        // Screen clip's distance from wrapper top
        const screenClipTopPx = screenClip.offsetTop;

        // Desired absolute Y for the fish (data-fish-y as % of section, 0–100).
        // TINKER: change data-fish-y on the xray-elements div in the liquid.
        const fishPct      = parseFloat(xrayElements.dataset.fishY) / 100 || 0.3347;
        const fishDrawingY = fishPct * sectionH;

        // C: fish translateY that places it at fishDrawingY when machine translateY = 0
        const C = fishDrawingY - machineTopPx - screenClipTopPx;

        // Machine travel range as multiples of wrapper height.
        // TINKER: change data-start / data-stop on the wrapper div in the liquid.
        const startMult = parseFloat(wrapper.dataset.start) ?? -1.0;
        const stopMult  = parseFloat(wrapper.dataset.stop)  ?? 0.15;
        const machineFrom = (toActive ? startMult : stopMult) * wrapperH;
        const machineTo   = (toActive ? stopMult  : startMult) * wrapperH;

        const duration  = 1300; // ms — TINKER here if you want faster/slower
        const startTime = performance.now();

        if (toActive) xrayActive = true;

        const step = (now) => {
          const t = Math.min((now - startTime) / duration, 1);
          const e = xrayEase(t);

          const machineY = machineFrom + (machineTo - machineFrom) * e;
          const fishY    = C - machineY; // exact inverse every frame

          wrapper.style.transform  = `translateY(${machineY}px)`;
          fishImg.style.transform  = `translateY(${fishY}px)`;

          if (t < 1) {
            xrayAnimFrame = requestAnimationFrame(step);
          } else {
            xrayAnimFrame = null;
            if (!toActive) xrayActive = false;
          }
        };

        xrayAnimFrame = requestAnimationFrame(step);
      };

      const showXray = () => {
        if (xrayActive || !xrayElements) return;
        animateXray(true);
      };

      const hideXray = () => {
        if (!xrayActive || !xrayElements) return;
        animateXray(false);
      };

      // Paper scroll state
      let scrollActive = false;
      const scrollWrap = section.querySelector('.chalkboard-panorama__scroll-wrap');

      const showScroll = () => {
        if (scrollActive || !scrollWrap) return;
        scrollActive = true;
        scrollWrap.classList.add('is-active');
      };

      const hideScroll = () => {
        if (!scrollActive || !scrollWrap) return;
        scrollWrap.classList.remove('is-active');
        scrollActive = false;
      };

      // Secret bar state
      let barState = 'hidden'; // 'hidden' | 'doors' | 'open' | 'revealed'
      const barModal = section.querySelector('.chalkboard-panorama__bar-modal');
      let djangoAudio = null;
      let djangoCtx = null;
      let djangoGain = null;

      const showBarDoors = () => {
        if (barState !== 'hidden' || !barModal) return;
        barState = 'doors';
        barModal.classList.add('is-active');
      };

      const openBarDoors = () => {
        if (barState !== 'doors' || !barModal) return;
        barState = 'open';
        barModal.classList.add('is-open');
        setTimeout(() => {
          const firstField = barModal.querySelector('.bar-field');
          if (firstField) firstField.focus();
        }, 650);

        // Fade in django.mp3 starting at 21s
        const djangoUrl = barModal.dataset.djangoUrl;
        if (!djangoAudio && djangoUrl) {
          djangoCtx = new (window.AudioContext || window.webkitAudioContext)();
          djangoGain = djangoCtx.createGain();
          djangoGain.gain.setValueAtTime(0, djangoCtx.currentTime);
          djangoGain.gain.linearRampToValueAtTime(1, djangoCtx.currentTime + 3);
          djangoGain.connect(djangoCtx.destination);
          djangoAudio = new Audio(djangoUrl);
          djangoAudio.crossOrigin = 'anonymous';
          djangoAudio.currentTime = 21;
          const djangoSource = djangoCtx.createMediaElementSource(djangoAudio);
          djangoSource.connect(djangoGain);
          djangoAudio.play().catch(() => {});
        }
      };

      const revealBar = () => {
        if (barState !== 'open' || !barModal) return;
        barState = 'revealed';
        barModal.classList.add('is-revealed');
      };

      const hideBar = () => {
        if (barState === 'hidden' || !barModal) return;
        barModal.classList.remove('is-active', 'is-open', 'is-revealed', 'is-wrong');
        barModal.querySelectorAll('.bar-field').forEach(f => { f.value = ''; });
        const errorEl = barModal.querySelector('.bar-password__error');
        if (errorEl) errorEl.textContent = '';
        barState = 'hidden';
        if (djangoAudio) {
          djangoAudio.pause();
          djangoAudio = null;
          djangoCtx = null;
          djangoGain = null;
        }
      };

      const setupBar = () => {
        if (!barModal) return;

        // Doors click → open
        const barDoors = barModal.querySelector('.bar-doors');
        if (barDoors) {
          barDoors.addEventListener('click', (e) => {
            e.stopPropagation();
            openBarDoors();
          });
        }

        // Password fields — auto-advance, backspace, letter-only
        const fields = Array.from(barModal.querySelectorAll('.bar-field'));
        const errorEl = barModal.querySelector('.bar-password__error');

        fields.forEach((field, i) => {
          field.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && !field.value && i > 0) {
              e.preventDefault();
              fields[i - 1].value = '';
              fields[i - 1].focus();
            } else if (e.key === 'ArrowLeft' && i > 0) {
              e.preventDefault(); fields[i - 1].focus();
            } else if (e.key === 'ArrowRight' && i < fields.length - 1) {
              e.preventDefault(); fields[i + 1].focus();
            } else if (e.key === 'Enter') {
              checkBarPassword();
            }
          });
          field.addEventListener('input', () => {
            const alpha = field.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
            field.value = alpha ? alpha[alpha.length - 1] : '';
            if (field.value && i < fields.length - 1) {
              fields[i + 1].focus();
              fields[i + 1].select();
            }
          });
        });

        const checkBarPassword = () => {
          const word1 = fields.slice(0, 5).map(f => f.value).join('');
          const word2 = fields.slice(5, 10).map(f => f.value).join('');
          if (`${word1} ${word2}` === 'EFFIE KOMAN') {
            revealBar();
          } else {
            if (errorEl) errorEl.textContent = '…try again.';
            barModal.classList.add('is-wrong');
            setTimeout(() => {
              barModal.classList.remove('is-wrong');
              if (errorEl) errorEl.textContent = '';
              fields.forEach(f => { f.value = ''; });
              fields[0].focus();
            }, 1200);
          }
        };

        const submitBtn = barModal.querySelector('.bar-password__submit');
        if (submitBtn) submitBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          checkBarPassword();
        });

        const hintModal = barModal.querySelector('.bar-hint-modal');
        if (hintModal) {
          barModal.addEventListener('click', (e) => {
            if (e.target.closest('.bar-password__hint-btn')) {
              e.stopPropagation();
              hintModal.classList.add('is-open');
              return;
            }
            if (hintModal.classList.contains('is-open')) {
              e.stopPropagation();
              hintModal.classList.remove('is-open');
            }
          });
        }
      };
      
      const stopSurfAnimation = (immediate = false) => {
        if (surfAnimationFrame) {
          cancelAnimationFrame(surfAnimationFrame);
          surfAnimationFrame = null;
        }
        if (surfTimeout) {
          clearTimeout(surfTimeout);
          surfTimeout = null;
        }
        if (surfAudio) {
          surfAudio.pause();
          surfAudio.currentTime = 0;
          surfAudio = null;
        }
        if (activeSurfDrawing) {
          activeSurfDrawing.classList.remove('is-surfing');
          activeSurfDrawing.style.transform = '';
          activeSurfDrawing = null;
        }
      };
      
      const startMatchaMode = () => {
        if (matchaActive || !matchaElements) return;
        
        matchaActive = true;
        matchaElements.classList.add('is-active');
        
        const audioStartTime = 0;
        const audioEndOffset = 0.32;
        matchaAudio = new Audio('https://cdn.shopify.com/s/files/1/0698/2814/9498/files/funkytown.m4a');
        matchaAudio.currentTime = audioStartTime;
        matchaAudio.addEventListener('loadedmetadata', () => {
          const checkTime = () => {
            if (matchaAudio && matchaAudio.currentTime >= matchaAudio.duration - audioEndOffset) {
              matchaAudio.currentTime = audioStartTime;
            }
          };
          matchaAudio.addEventListener('timeupdate', checkTime);
        });
        matchaAudio.play().catch((e) => {
          console.warn('Matcha audio playback failed:', e);
        });
      };
      
      const stopMatchaMode = () => {
        if (!matchaActive || !matchaElements) return;
        
        matchaActive = false;
        matchaElements.classList.remove('is-active');
        
        if (matchaAudio) {
          matchaAudio.pause();
          matchaAudio.currentTime = 0;
          matchaAudio = null;
        }
      };
      
      const playThunderSound = () => {
        const audio = new Audio('https://cdn.shopify.com/s/files/1/0698/2814/9498/files/thunder.mp3');
        audio.crossOrigin = 'anonymous';
        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const source = audioCtx.createMediaElementSource(audio);
        const gainNode = audioCtx.createGain();
        gainNode.gain.value = 3.0;
        source.connect(gainNode);
        gainNode.connect(audioCtx.destination);
        audio.play().catch((e) => {
          console.warn('Thunder audio playback failed:', e);
        });
      };

      const triggerLightningStrike = (drawing) => {
        const drawingRect = drawing.getBoundingClientRect();
        const sectionRect = section.getBoundingClientRect();

        const targetX = drawingRect.left - sectionRect.left + drawingRect.width / 2;
        const targetY = drawingRect.top - sectionRect.top + drawingRect.height * 0.15;
        const startX = targetX + (Math.random() - 0.5) * 60;

        let canvas = section.querySelector('.chalkboard-panorama__lightning-canvas');
        if (!canvas) {
          canvas = document.createElement('canvas');
          canvas.className = 'chalkboard-panorama__lightning-canvas';
          section.appendChild(canvas);
        }
        canvas.width = section.offsetWidth;
        canvas.height = section.offsetHeight;
        const ctx = canvas.getContext('2d');

        let flash = section.querySelector('.chalkboard-panorama__lightning-flash');
        if (!flash) {
          flash = document.createElement('div');
          flash.className = 'chalkboard-panorama__lightning-flash';
          section.appendChild(flash);
        }

        playThunderSound();

        // Midpoint displacement: generates jagged bolt points recursively
        const generateBoltPoints = (sx, sy, ex, ey, depth, disp) => {
          if (depth === 0) return [{ x: sx, y: sy }, { x: ex, y: ey }];
          const mx = (sx + ex) / 2 + (Math.random() - 0.5) * disp;
          const my = (sy + ey) / 2 + (Math.random() - 0.5) * disp * 0.12;
          const left = generateBoltPoints(sx, sy, mx, my, depth - 1, disp * 0.55);
          const right = generateBoltPoints(mx, my, ex, ey, depth - 1, disp * 0.55);
          return [...left.slice(0, -1), ...right];
        };

        const drawBoltPath = (points, lineWidth, color, blur, blurColor) => {
          ctx.beginPath();
          ctx.moveTo(points[0].x, points[0].y);
          for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y);
          ctx.strokeStyle = color;
          ctx.lineWidth = lineWidth;
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';
          ctx.shadowBlur = blur;
          ctx.shadowColor = blurColor;
          ctx.stroke();
        };

        const renderFrame = () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          const points = generateBoltPoints(startX, 0, targetX, targetY, 7, 130);

          // Three layers: outer glow → mid glow → white core
          drawBoltPath(points, 9,   'rgba(80, 140, 255, 0.25)', 50, 'rgba(80, 140, 255, 0.9)');
          drawBoltPath(points, 4,   'rgba(170, 210, 255, 0.75)', 22, 'rgba(170, 210, 255, 1)');
          drawBoltPath(points, 1.5, 'rgba(255, 255, 255, 1)',     8, 'white');

          // 2–3 side branches
          const branchCount = 2 + Math.floor(Math.random() * 2);
          for (let b = 0; b < branchCount; b++) {
            const idx = Math.floor(points.length * (0.15 + Math.random() * 0.55));
            const bp = points[idx];
            const angle = (Math.random() - 0.5) * 1.4;
            const len = 30 + Math.random() * 65;
            const bex = bp.x + Math.sin(angle) * len;
            const bey = bp.y + Math.cos(angle) * len * 0.9;
            const branchPts = generateBoltPoints(bp.x, bp.y, bex, bey, 4, 38);
            drawBoltPath(branchPts, 2,   'rgba(140, 195, 255, 0.55)', 12, 'rgba(140, 195, 255, 0.8)');
            drawBoltPath(branchPts, 0.8, 'rgba(230, 245, 255, 0.85)',  4, 'white');
          }
        };

        // Flicker sequence: [show, durationMs]
        const sequence = [
          [true,  45],   // pre-flicker 1
          [false, 75],
          [true,  35],   // pre-flicker 2
          [false, 110],
          [true,  230],  // main strike
          [false, 50],
          [true,  85],   // after-glow
          [false, 0],
        ];

        let step = 0;
        const run = () => {
          if (step >= sequence.length) return;
          const [show, dur] = sequence[step++];

          if (show) {
            renderFrame();
            flash.style.opacity = step <= 2 ? '0.22' : step <= 5 ? '0.55' : '0.28';
          } else {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            flash.style.opacity = '0';
          }

          if (step < sequence.length) setTimeout(run, dur);
        };

        run();
      };

      // ============================================================
      // DREIDEL GAME
      // ============================================================

      // 8-bit melody: "I Have a Little Dreidel" in G major
      const DQ = 60 / 108;
      const DH = DQ * 2;
      const DE = DQ / 2;
      const GN5 = 783.99, AN5 = 880, BN5 = 987.77, CN6 = 1046.50, DN6 = 1174.66, EN6 = 1318.51, FN6 = 1396.91, GN6 = 1567.98;
      const DREIDEL_MELODY = [
        [GN5,DE],[CN6,DE],[CN6,DE],[DN6,DE],[DN6,DE],[EN6,DE],[CN6,DE],[0,DE],
        [EN6,DE],[GN6,DE],[GN6,DE],[FN6,DE],[EN6,DE],[DN6,DQ],[0,DE],
        [AN5,DE],[DN6,DE],[DN6,DE],[EN6,DE],[EN6,DE],[FN6,DE],[DN6,DE],[0,DE],
        [EN6,DE],[GN6,DE],[FN6,DE],[EN6,DE],[DN6,DE],[CN6,DE],[0,DQ],
        [EN6,DE],[GN6,DE],[EN6,DE],[GN6,DE],[EN6,DE],[GN6,DE],[EN6,DE],[0,DE],
        [EN6,DE],[GN6,DE],[GN6,DE],[FN6,DE],[EN6,DE],[DN6,DE],[0,DQ],
        [DN6,DE],[FN6,DE],[DN6,DE],[FN6,DE],[DN6,DE],[FN6,DE],[DN6,DE],[0,DE],
        [EN6,DE],[GN6,DE],[FN6,DE],[EN6,DE],[DN6,DE],[CN6,DE],[0,DQ],
      ];
      // Pixel-art sprites (8-wide rows, '.' = transparent)
      const YOU_ROWS = [
        '...kk...',
        '..kkkk..',
        '..ssss..',
        '.shsshs.',
        '..ssss..',
        '.bbbbbb.',
        '.bbbbbb.',
        '.bbbbbb.',
        '..pp.pp.',
        '..pp.pp.',
        '..pp.pp.',
        '..ee.ee.',
      ];
      const JAKE_ROWS = [
        '..hhhh..',  // dark hair
        '.hhhhhh.',  // dark hair
        '..ssss..',  // forehead
        '.fhffhf.',  // glasses frames (f) around pupils (h)
        '..ssss..',  // lower face
        '.BBBBBB.',  // beard
        '.gwwwgg.',  // green shirt — G top arc
        '.wgggwg.',  // green shirt — G sides + inner bar
        '.gwwwwg.',  // green shirt — G bottom (wider = the G notch)
        '..dd.dd.',  // pants
        '..dd.dd.',  // pants
        '..ee.ee.',  // shoes
      ];
      const YOU_PAL  = { k:'#1a5db5', s:'#FFCC88', h:'#333', b:'#4477FF', p:'#223355', e:'#111' };
      const JAKE_PAL = { h:'#3D1C02', s:'#FFCC88', B:'#7B3F00', f:'#555', g:'#228B22', w:'#fff', d:'#442211', e:'#111' };

      const drawSpriteOnCanvas = (canvas, rows, pal, scale) => {
        if (!canvas) return;
        canvas.width  = rows[0].length * scale;
        canvas.height = rows.length * scale;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        rows.forEach((row, y) => {
          [...row].forEach((c, x) => {
            if (c !== '.') {
              ctx.fillStyle = pal[c] || '#f0f';
              ctx.fillRect(x * scale, y * scale, scale, scale);
            }
          });
        });
      };

      let dreidelState = null;
      let dreidelMusicCtx = null;
      let dreidelMusicRunning = false;
      let dreidelMusicTimeout = null;

      const initDreidelState = () => ({
        youCoins: 5, jakeCoins: 5, pot: 0,
        turn: 'you', phase: 'ante', spinning: false,
      });

      const getDreidelI18n = (modal) => {
        try {
          const raw = modal.querySelector('.dreidel-game')?.dataset?.i18n || '{}';
          const txt = document.createElement('textarea');
          txt.innerHTML = raw;
          return JSON.parse(txt.value);
        }
        catch(e) { return {}; }
      };
      const dt = (i18n, key, fallback) => i18n[key] || fallback;

      const openDreidelGame = () => {
        const modal = section.querySelector('.chalkboard-panorama__dreidel-modal');
        if (!modal) return;
        const i18n = getDreidelI18n(modal);
        dreidelState = initDreidelState();
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        drawSpriteOnCanvas(modal.querySelector('#dreidel-canvas-you'),  YOU_ROWS,  YOU_PAL,  5);
        drawSpriteOnCanvas(modal.querySelector('#dreidel-canvas-jake'), JAKE_ROWS, JAKE_PAL, 5);
        renderDreidelCanvas(modal, null);
        renderDreidelUI(modal);
        // Show intro before game starts
        const intro = modal.querySelector('#dreidel-intro');
        if (intro) intro.classList.add('is-active');
        setDreidelBtn(modal, dt(i18n, 'letsPlay', "► LETS PLAY!"), () => {
          if (intro) intro.classList.remove('is-active');
          startDreidelRound(modal);
          startDreidelMusic();
        });
      };

      const closeDreidelGame = () => {
        const modal = section.querySelector('.chalkboard-panorama__dreidel-modal');
        if (!modal) return;
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        stopDreidelMusic();
        dreidelState = null;
      };

      const clearResultHeader = (modal) => {
        modal.querySelector('#dreidel-result-header')?.classList.remove('is-visible');
      };

      const showResultHeader = (modal, letter, isYou) => {
        const el = modal.querySelector('#dreidel-result-header');
        if (!el) return;
        const i18n = getDreidelI18n(modal);
        const desc = {
          'נ': dt(i18n, 'nunResult',      'NUN — NOTHING HAPPENS'),
          'ג': isYou ? dt(i18n, 'showGimmelYou',  'GIMMEL — YOU TAKE EVERYTHING!')
                     : dt(i18n, 'showGimmelJake', 'GIMMEL — JAKE GREENBERG TAKES EVERYTHING!'),
          'ה': isYou ? dt(i18n, 'showHeyYou',     'HEY — YOU TAKE HALF THE POT')
                     : dt(i18n, 'showHeyJake',    'HEY — JAKE GREENBERG TAKES HALF THE POT'),
          'ש': isYou ? dt(i18n, 'showShinYou',    'SHIN — YOU ADD 1 COIN TO THE POT')
                     : dt(i18n, 'showShinJake',   'SHIN — JAKE GREENBERG ADDS 1 COIN TO THE POT'),
        };
        el.textContent = `${letter}  ${desc[letter] || ''}`;
        el.classList.add('is-visible');
      };

      const startDreidelRound = (modal) => {
        clearResultHeader(modal);
        renderDreidelUI(modal);
        const i18n = getDreidelI18n(modal);
        if (dreidelState.turn === 'you') {
          setDreidelMsg(modal, dt(i18n, 'yourTurn', 'YOUR TURN — PUT A COIN IN THE POT'));
          setDreidelBtn(modal, dt(i18n, 'anteUp', 'ANTE UP ▶'), () => doAnte(modal, 'you'));
        } else {
          setDreidelMsg(modal, dt(i18n, 'jakesTurn', "JAKE GREENBERG GOES..."));
          setDreidelBtn(modal, '', null, true);
          setTimeout(() => doAnte(modal, 'jake'), 1200);
        }
      };

      const doAnte = (modal, who) => {
        if (!dreidelState) return;
        const i18n = getDreidelI18n(modal);
        if (dreidelState[`${who}Coins`] <= 0) {
          endDreidelGame(modal, who === 'you' ? 'jake' : 'you');
          return;
        }
        dreidelState[`${who}Coins`]--;
        dreidelState.pot++;
        renderDreidelUI(modal);
        dreidelState.phase = 'spin';

        if (who === 'you') {
          setDreidelMsg(modal, dt(i18n, 'spinPrompt', 'GOOD. NOW SPIN THE DREIDEL!'));
          setDreidelBtn(modal, dt(i18n, 'spin', '🌀 SPIN!'), () => doSpin(modal, 'you'));
        } else {
          setDreidelMsg(modal, dt(i18n, 'jakeAnted', "JAKE GREENBERG ANTED UP — JAKE GREENBERG IS SPINNING..."));
          setDreidelBtn(modal, '', null, true);
          setTimeout(() => doSpin(modal, 'jake'), 900);
        }
      };

      const DREIDEL_LETTERS = ['נ', 'ג', 'ה', 'ש'];
      const DREIDEL_LETTER_NAMES = { 'נ': 'NUN', 'ג': 'GIMMEL', 'ה': 'HEY', 'ש': 'SHIN' };

      const DREIDEL_PX = 8;
      const DREIDEL_PIXELS = [
        [0,0,0,1,1,1,0,0,0],
        [0,0,0,1,0,1,0,0,0],
        [0,0,0,1,0,1,0,0,0],
        [1,1,1,1,0,1,1,1,1],
        [1,0,0,0,0,0,0,0,1],
        [1,0,0,0,0,0,0,0,1],
        [1,0,0,0,0,0,0,0,1],
        [1,0,0,0,0,0,0,0,1],
        [1,0,0,0,0,0,0,0,1],
        [0,1,0,0,0,0,0,1,0],
        [0,0,1,0,0,0,1,0,0],
        [0,0,0,1,0,1,0,0,0],
        [0,0,0,0,1,0,0,0,0],
      ];
      const DREIDEL_GLYPHS = {
        'נ': [[0,0,1],[0,0,1],[0,0,1],[1,1,1]],
        'ג': [[1,1,0],[0,0,1],[0,1,1],[1,0,1]],
        'ה': [[1,1,1],[0,0,1],[1,0,1],[1,0,1]],
        'ש': [[1,0,1],[1,1,1],[1,1,1],[0,1,0]],
      };
      const DREIDEL_COLS = 9;
      const DREIDEL_GLYPH_COL = Math.floor((DREIDEL_COLS - 3) / 2); // centre a 3-wide glyph
      const DREIDEL_GLYPH_ROW = 5; // start in the 6th row (0-indexed)

      const renderDreidelCanvas = (modal, letter) => {
        const canvas = modal.querySelector('#dreidel-top');
        if (!canvas || !canvas.getContext) return;
        const ctx = canvas.getContext('2d');
        const px = DREIDEL_PX;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const DREIDEL_COLOURS = {
          'נ': { fill: '#44bb44', border: '#1a6b1a' },
          'ג': { fill: '#ddcc22', border: '#998800' },
          'ה': { fill: '#ee7722', border: '#994400' },
          'ש': { fill: '#9944cc', border: '#662299' },
        };
        const col = DREIDEL_COLOURS[letter] || { fill: '#44bb44', border: '#1a6b1a' };

        // Draw filled dreidel shape row by row
        for (let r = 0; r < DREIDEL_PIXELS.length; r++) {
          const row = DREIDEL_PIXELS[r];
          let left = -1, right = -1;
          for (let c = 0; c < row.length; c++) {
            if (row[c]) { if (left === -1) left = c; right = c; }
          }
          if (left === -1) continue;
          // Interior fill
          ctx.fillStyle = col.fill;
          ctx.fillRect(left * px, r * px, (right - left + 1) * px, px);
          // Border pixels
          ctx.fillStyle = col.border;
          for (let c = left; c <= right; c++) {
            if (row[c]) ctx.fillRect(c * px, r * px, px, px);
          }
        }

        // Draw Hebrew letter glyph
        const glyph = DREIDEL_GLYPHS[letter];
        if (glyph) {
          ctx.fillStyle = '#ffffff';
          for (let gr = 0; gr < glyph.length; gr++) {
            for (let gc = 0; gc < glyph[gr].length; gc++) {
              if (glyph[gr][gc]) {
                ctx.fillRect(
                  (DREIDEL_GLYPH_COL + gc) * px,
                  (DREIDEL_GLYPH_ROW + gr) * px,
                  px, px
                );
              }
            }
          }
        }
      };

      const doSpin = (modal, who) => {
        if (!dreidelState || dreidelState.spinning) return;
        dreidelState.spinning = true;
        setDreidelBtn(modal, '...', null, true);

        const result = DREIDEL_LETTERS[Math.floor(Math.random() * 4)];
        // Delays between frames: fast → slow, like a spinning wheel winding down
        const SPIN_DELAYS = [50, 60, 70, 80, 95, 115, 145, 185, 235, 295, 360];
        let tick = 0;
        const spinStep = () => {
          if (tick < SPIN_DELAYS.length) {
            renderDreidelCanvas(modal, DREIDEL_LETTERS[Math.floor(Math.random() * 4)]);
            setTimeout(spinStep, SPIN_DELAYS[tick++]);
          } else {
            renderDreidelCanvas(modal, result);
            dreidelState.spinning = false;
            setTimeout(() => applyDreidelResult(modal, who, result), 550);
          }
        };
        spinStep();
      };

      const applyDreidelResult = (modal, who, letter) => {
        if (!dreidelState) return;
        const isYou = who === 'you';
        const i18n  = getDreidelI18n(modal);
        let msg = '';

        if (letter === 'נ') {
          msg = dt(i18n, 'nunResult', 'NUN — NOTHING HAPPENS');
        } else if (letter === 'ג') {
          const won = dreidelState.pot;
          dreidelState[`${who}Coins`] += won;
          dreidelState.pot = 0;
          const coinWord = won !== 1 ? dt(i18n, 'coinsCap', 'COINS') : dt(i18n, 'coin', 'COIN');
          const tpl = isYou ? dt(i18n, 'gimmelYou', 'GIMMEL! YOU TAKE ALL {{n}} COINS!')
                            : dt(i18n, 'gimmelJake', 'GIMMEL! JAKE GREENBERG TAKES ALL {{n}} COINS!');
          msg = tpl.replace('{{n}}', won).replace('COINS', coinWord).replace('COIN', coinWord);
        } else if (letter === 'ה') {
          const won = Math.floor(dreidelState.pot / 2);
          dreidelState[`${who}Coins`] += won;
          dreidelState.pot -= won;
          const coinWord = won !== 1 ? dt(i18n, 'coinsCap', 'COINS') : dt(i18n, 'coin', 'COIN');
          const tpl = isYou ? dt(i18n, 'heyYou', 'HEY! YOU TAKE {{n}} {{coin}}!')
                            : dt(i18n, 'heyJake', 'HEY! JAKE GREENBERG TAKES {{n}} {{coin}}!');
          msg = tpl.replace('{{n}}', won).replace('{{coin}}', coinWord);
        } else if (letter === 'ש') {
          if (dreidelState[`${who}Coins`] > 0) {
            dreidelState[`${who}Coins`]--;
            dreidelState.pot++;
            msg = isYou ? dt(i18n, 'shinYouAdd',      'SHIN — YOU ADD 1 COIN TO THE POT')
                        : dt(i18n, 'shinJakeAdd',     'SHIN — JAKE GREENBERG ADDS 1 COIN TO THE POT');
          } else {
            msg = isYou ? dt(i18n, 'shinYouNoCoins',  'SHIN — YOU HAVE NO COINS TO ADD!')
                        : dt(i18n, 'shinJakeNoCoins', 'SHIN — JAKE GREENBERG HAS NO COINS TO ADD!');
          }
        }

        showResultHeader(modal, letter, isYou);
        renderDreidelUI(modal);
        setDreidelMsg(modal, msg);
        dreidelState.phase = 'result';

        setTimeout(() => {
          if (!dreidelState) return;
          if (dreidelState.youCoins  <= 0 && dreidelState.pot === 0) { endDreidelGame(modal, 'jake'); return; }
          if (dreidelState.jakeCoins <= 0 && dreidelState.pot === 0) { endDreidelGame(modal, 'you');  return; }
          dreidelState.turn  = dreidelState.turn === 'you' ? 'jake' : 'you';
          dreidelState.phase = 'ante';
          startDreidelRound(modal);
        }, 1900);
      };

      const endDreidelGame = (modal, winner) => {
        if (!dreidelState) return;
        dreidelState.phase = 'gameover';
        dreidelState[`${winner}Coins`] += dreidelState.pot;
        dreidelState.pot = 0;
        renderDreidelUI(modal);
        stopDreidelMusic();

        const i18n = getDreidelI18n(modal);
        if (winner === 'you') {
          setDreidelMsg(modal, dt(i18n, 'youWin', '★  YOU WIN!  HAPPY HANUKKAH!  ★'));
          playDreidelVictory();
        } else {
          setDreidelMsg(modal, dt(i18n, 'jakeWins', 'JAKE GREENBERG WINS!  BETTER LUCK NEXT SPIN!'));
        }
        setDreidelBtn(modal, dt(i18n, 'playAgain', '▶ PLAY AGAIN'), () => {
          dreidelState = initDreidelState();
          startDreidelRound(modal);
          startDreidelMusic();
        });
      };

      const renderDreidelUI = (modal) => {
        if (!dreidelState) return;
        renderDreidelStacks(modal, 'you',  dreidelState.youCoins);
        renderDreidelStacks(modal, 'jake', dreidelState.jakeCoins);
        renderDreidelPot(modal, dreidelState.pot);
        modal.querySelector('#dreidel-side-you')?.classList.toggle('is-active-turn',  dreidelState.turn === 'you');
        modal.querySelector('#dreidel-side-jake')?.classList.toggle('is-active-turn', dreidelState.turn === 'jake');
      };

      const renderDreidelStacks = (modal, who, count) => {
        const el      = modal.querySelector(`#dreidel-stacks-${who}`);
        const countEl = modal.querySelector(`#dreidel-count-${who}`);
        if (!el) return;
        el.innerHTML = '';
        for (let s = 0; s < 4; s++) {
          const stack = document.createElement('div');
          stack.className = 'dreidel-stack';
          for (let c = 4; c >= 0; c--) {
            const coin = document.createElement('div');
            coin.className = `dreidel-coin${(s * 5 + c) < count ? '' : ' dreidel-coin--empty'}`;
            stack.appendChild(coin);
          }
          el.appendChild(stack);
        }
        if (countEl) countEl.textContent = count;
      };

      const renderDreidelPot = (modal, count) => {
        const el      = modal.querySelector('#dreidel-pot-coins');
        const countEl = modal.querySelector('#dreidel-count-pot');
        if (!el) return;
        el.innerHTML = '';
        for (let i = 0; i < Math.min(count, 16); i++) {
          const coin = document.createElement('div');
          coin.className = 'dreidel-coin dreidel-coin--pot';
          el.appendChild(coin);
        }
        if (countEl) countEl.textContent = count;
      };

      const setDreidelMsg = (modal, text) => {
        const el = modal.querySelector('#dreidel-message');
        if (el) el.textContent = text;
      };

      const setDreidelBtn = (modal, text, handler, disabled = false) => {
        const btn = modal.querySelector('#dreidel-btn');
        if (!btn) return;
        btn.textContent      = text || '';
        btn.disabled         = disabled || !handler;
        btn.style.visibility = text ? 'visible' : 'hidden';
        btn.onclick          = handler || null;
      };

      const startDreidelMusic = () => {
        stopDreidelMusic();
        try { dreidelMusicCtx = new (window.AudioContext || window.webkitAudioContext)(); }
        catch (e) { return; }
        dreidelMusicRunning = true;
        const master = dreidelMusicCtx.createGain();
        master.gain.value = 0.1;
        master.connect(dreidelMusicCtx.destination);
        let scheduleAt = dreidelMusicCtx.currentTime + 0.05;

        const scheduleLoop = () => {
          if (!dreidelMusicRunning || !dreidelMusicCtx) return;
          DREIDEL_MELODY.forEach(([freq, dur]) => {
            if (freq > 0) {
              const osc = dreidelMusicCtx.createOscillator();
              osc.type = 'square';
              osc.frequency.value = freq;
              const env = dreidelMusicCtx.createGain();
              env.gain.setValueAtTime(1, scheduleAt);
              env.gain.setValueAtTime(1, scheduleAt + dur * 0.82);
              env.gain.linearRampToValueAtTime(0, scheduleAt + dur * 0.95);
              osc.connect(env);
              env.connect(master);
              osc.start(scheduleAt);
              osc.stop(scheduleAt + dur);
            }
            scheduleAt += dur;
          });
          const totalDur = DREIDEL_MELODY.reduce((s, [, d]) => s + d, 0);
          dreidelMusicTimeout = setTimeout(scheduleLoop, (scheduleAt - dreidelMusicCtx.currentTime) * 1000 - 400);
        };
        scheduleLoop();
      };

      const stopDreidelMusic = () => {
        dreidelMusicRunning = false;
        if (dreidelMusicTimeout) { clearTimeout(dreidelMusicTimeout); dreidelMusicTimeout = null; }
        if (dreidelMusicCtx) { dreidelMusicCtx.close().catch(() => {}); dreidelMusicCtx = null; }
      };

      const playDreidelVictory = () => {
        try {
          const ctx    = new (window.AudioContext || window.webkitAudioContext)();
          const master = ctx.createGain();
          master.gain.value = 0.15;
          master.connect(ctx.destination);
          const fanfare = [
            [523.25,0.12],[659.25,0.12],[783.99,0.12],[1046.50,0.35],
            [0,0.06],[783.99,0.10],[1046.50,0.45],
          ];
          let t = ctx.currentTime + 0.05;
          fanfare.forEach(([f, d]) => {
            if (f > 0) {
              const o = ctx.createOscillator(); o.type = 'square'; o.frequency.value = f;
              const g = ctx.createGain();
              g.gain.setValueAtTime(1, t);
              g.gain.linearRampToValueAtTime(0, t + d * 0.9);
              o.connect(g); g.connect(master); o.start(t); o.stop(t + d);
            }
            t += d;
          });
        } catch (e) {}
      };

      const setupDreidelModal = () => {
        const modal = section.querySelector('.chalkboard-panorama__dreidel-modal');
        if (!modal) return;
        modal.querySelector('.chalkboard-panorama__dreidel-overlay')?.addEventListener('click', closeDreidelGame);
        modal.querySelector('.dreidel-game__close')?.addEventListener('click', closeDreidelGame);
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.classList.contains('is-active')) closeDreidelGame();
        });
      };

      const startSurfAnimation = (drawing) => {
        stopSurfAnimation();
        
        const audioUrl = drawing.dataset.audioUrl;
        const audioStart = parseFloat(drawing.dataset.audioStart) || 0;
        const audioEnd = parseFloat(drawing.dataset.audioEnd) || null;
        
        if (!audioUrl) return;
        
        activeSurfDrawing = drawing;
        drawing.classList.add('is-surfing');
        
        surfAudio = new Audio(audioUrl);
        surfAudio.currentTime = audioStart;
        
        const wiggleDuration = 1000;
        const slideDuration = 6000;
        const offscreenWaitDuration = 2000;
        const startTime = Date.now();
        let phase = 'wiggle';
        let slideStartTime = null;
        
        const animate = () => {
          const elapsed = Date.now() - startTime;
          const drawingRect = drawing.getBoundingClientRect();
          
          if (phase === 'wiggle') {
            const wiggleProgress = elapsed / wiggleDuration;
            if (wiggleProgress >= 1) {
              phase = 'slide';
              slideStartTime = Date.now();
              drawing.style.transform = '';
            } else {
              const wiggleAngle = Math.sin(wiggleProgress * Math.PI * 6) * 3 * (1 - wiggleProgress * 0.3);
              drawing.style.transform = `rotate(${wiggleAngle}deg)`;
            }
          }
          
          if (phase === 'slide') {
            const slideElapsed = Date.now() - slideStartTime;
            const slideProgress = Math.min(slideElapsed / slideDuration, 1);
            const easeOut = 1 - Math.pow(1 - slideProgress, 2);
            const slideDistance = window.innerWidth * 1.5;
            drawing.style.transform = `translateX(${slideDistance * easeOut}px)`;
            
            if (drawingRect.left > window.innerWidth && phase !== 'offscreen') {
              phase = 'offscreen';
              surfTimeout = setTimeout(() => {
                if (surfAudio) {
                  surfAudio.pause();
                  surfAudio.currentTime = 0;
                  surfAudio = null;
                }
                if (activeSurfDrawing) {
                  activeSurfDrawing.classList.remove('is-surfing');
                  activeSurfDrawing.style.transform = '';
                  activeSurfDrawing = null;
                }
              }, offscreenWaitDuration);
              return;
            }
            
            if (slideProgress >= 1 && phase !== 'offscreen') {
              phase = 'offscreen';
              surfTimeout = setTimeout(() => {
                if (surfAudio) {
                  surfAudio.pause();
                  surfAudio.currentTime = 0;
                  surfAudio = null;
                }
                if (activeSurfDrawing) {
                  activeSurfDrawing.classList.remove('is-surfing');
                  activeSurfDrawing.style.transform = '';
                  activeSurfDrawing = null;
                }
              }, offscreenWaitDuration);
              return;
            }
          }
          
          if (phase !== 'offscreen') {
            surfAnimationFrame = requestAnimationFrame(animate);
          }
        };
        
        surfAudio.play().then(() => {
          surfAnimationFrame = requestAnimationFrame(animate);
        }).catch((e) => {
          console.warn('Audio playback failed:', e);
          surfAnimationFrame = requestAnimationFrame(animate);
        });
      };
      
      const closeSwungDrawing = () => {
        if (activeSwungDrawing) {
          activeSwungDrawing.classList.remove('is-swung');
          activeSwungDrawing = null;
        }
      };
      
      const setupClickableDrawings = () => {
        const clickableDrawings = section.querySelectorAll('.chalkboard-panorama__drawing--clickable');
        
        clickableDrawings.forEach((drawing) => {
          drawing.addEventListener('click', (e) => {
            e.stopPropagation();
            const action = drawing.dataset.clickAction || 'none';
            
            if (action === 'swing') {
              if (drawing.classList.contains('is-swung')) {
                drawing.classList.remove('is-swung');
                activeSwungDrawing = null;
              } else {
                closeSwungDrawing();
                drawing.classList.add('is-swung');
                activeSwungDrawing = drawing;
              }
            }
            
            if (action === 'pop') {
              if (!drawing.classList.contains('is-popped')) {
                drawing.classList.add('is-popped');
                const duration = parseFloat(drawing.dataset.clickDuration) || 2;
                setTimeout(() => {
                  drawing.classList.remove('is-popped');
                }, duration * 1000);
              }
            }
            
            if (action === 'video') {
              const videoId = drawing.dataset.videoId;
              const startTime = parseInt(drawing.dataset.videoStart) || 0;
              const endTime = drawing.dataset.videoEnd ? parseInt(drawing.dataset.videoEnd) : null;
              const tvFrame = drawing.dataset.tvFrame;
              
              if (videoId) {
                showVideoPopupFromDrawing(videoId, startTime, endTime, tvFrame);
              }
            }
            
            if (action === 'link') {
              const link = drawing.dataset.link;
              if (link) {
                window.open(link, '_blank');
              }
            }
            
            if (action === 'tooltip') {
              const text = drawing.dataset.tooltipText;
              const heightMultiplier = parseFloat(drawing.dataset.tooltipHeight) || 2;
              
              if (text && !drawing._tooltipActive) {
                showTooltip(drawing, text, heightMultiplier);
              }
            }
            
            if (action === 'iframe') {
              const link = drawing.dataset.link;
              if (link) {
                showIframeModal(link);
              }
            }
            
            if (action === 'surf') {
              if (!drawing.classList.contains('is-surfing')) {
                startSurfAnimation(drawing);
              }
            }
            
            if (action === 'audio') {
              const audioUrl = drawing.dataset.audioUrl;
              if (audioUrl && !activeAudio) {
                const audio = new Audio(audioUrl);
                audio.crossOrigin = 'anonymous';
                const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                const source = audioCtx.createMediaElementSource(audio);
                const gainNode = audioCtx.createGain();
                gainNode.gain.value = 3.0;
                source.connect(gainNode);
                gainNode.connect(audioCtx.destination);
                activeAudio = audio;
                audio.addEventListener('ended', () => { activeAudio = null; });
                audio.play().catch((e) => {
                  console.warn('Audio playback failed:', e);
                  activeAudio = null;
                });
              }
            }
            
            if (action === 'matcha') {
              if (!matchaActive) {
                startMatchaMode();
              }
            }

            if (action === 'lightning') {
              triggerLightningStrike(drawing);
            }

            if (action === 'dreidel') {
              openDreidelGame();
            }
            
            if (action === 'krabs') {
              showKrabs();
            }

            if (action === 'xray') {
              if (xrayActive) {
                hideXray();
              } else {
                showXray();
              }
            }

            if (action === 'scroll') {
              if (scrollActive) {
                hideScroll();
              } else {
                showScroll();
              }
            }

            if (action === 'secretbar') {
              if (barState === 'hidden') {
                showBarDoors();
              } else {
                hideBar();
              }
            }
          });
        });
        
        // Setup matcha click-outside-to-close (clicking mask dismisses)
        if (matchaMask) {
          matchaMask.addEventListener('click', (e) => {
            e.stopPropagation();
            stopMatchaMode();
          });
        }
        
        // Close swung drawing when clicking elsewhere, stop surf, collapse scroll
        section.addEventListener('click', (e) => {
          if (activeSwungDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            closeSwungDrawing();
          }
          if (activeSurfDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            stopSurfAnimation();
          }
          if (scrollActive && !e.target.closest('.chalkboard-panorama__drawing--clickable') && !e.target.closest('.chalkboard-panorama__scroll-wrap')) {
            hideScroll();
          }
          if (barState !== 'hidden' && !e.target.closest('.chalkboard-panorama__bar-modal') && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            hideBar();
          }
        });
        
        // Close swung drawing and stop surf animation when scrolling starts
        section.addEventListener('mousedown', (e) => {
          if (activeSwungDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            closeSwungDrawing();
          }
          if (activeSurfDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            stopSurfAnimation();
          }
        });
        
        section.addEventListener('touchstart', (e) => {
          if (activeSwungDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            closeSwungDrawing();
          }
          if (activeSurfDrawing && !e.target.closest('.chalkboard-panorama__drawing--clickable')) {
            stopSurfAnimation();
          }
        });
      };
      
      const setupPopup = () => {
        if (!popup) return;
        
        const overlay = popup.querySelector('.chalkboard-panorama__popup-overlay');
        const closeBtn = popup.querySelector('.chalkboard-panorama__popup-close');
        
        if (overlay) overlay.addEventListener('click', closePopup);
        if (closeBtn) closeBtn.addEventListener('click', closePopup);
        
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && popup.classList.contains('is-active')) {
            closePopup();
          }
        });
      };
      
      // Keyboard navigation
      const onKeyDown = (e) => {
        if (!section.matches(':focus-within') && document.activeElement !== section) return;
        
        const step = 100;
        
        if (e.key === 'ArrowLeft') {
          currentX = Math.min(0, currentX + step);
          track.style.transform = `translateX(${currentX}px)`;
          updateProgress();
          updateLinkRegions();
          updateDrawings();
          updateMatchaElements();
          updateKrabsElement();
          updateXrayElements();
          updateScrollWrap();
          updateBarModal();
          hideScrollHint();
          e.preventDefault();
        } else if (e.key === 'ArrowRight') {
          currentX = Math.max(-dimensions.maxScroll, currentX - step);
          track.style.transform = `translateX(${currentX}px)`;
          updateProgress();
          updateLinkRegions();
          updateDrawings();
          updateMatchaElements();
          updateKrabsElement();
          updateXrayElements();
          updateScrollWrap();
          updateBarModal();
          hideScrollHint();
          e.preventDefault();
        }
      };
      
      // Setup event listeners
      section.addEventListener('mousedown', onMouseDown);
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
      section.addEventListener('touchstart', onTouchStart, { passive: true });
      section.addEventListener('touchmove', onTouchMove, { passive: true });
      section.addEventListener('touchend', onTouchEnd);
      section.addEventListener('wheel', onWheel, { passive: false });
      section.addEventListener('keydown', onKeyDown);
      
      // Allow section to receive keyboard focus
      section.setAttribute('tabindex', '0');
      
      // Initialize - wait for all images to load
      let loadedCount = 0;
      const totalImages = images.length;
      
      const onImageLoad = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          updateDimensions();
        }
      };
      
      images.forEach((img) => {
        if (img.complete) {
          onImageLoad();
        } else {
          img.addEventListener('load', onImageLoad);
        }
      });
      
      window.addEventListener('resize', updateDimensions);
      
      setupHotspots();
      setupPopup();
      setupVideoPopup();
      setupIframeModal();
      setupLinkRegions();
      setupClickableDrawings();
      setupBar();
      setupDreidelModal();

      // Auto-hide scroll hint after delay
      setTimeout(() => {
        if (!hasInteracted && scrollHint) {
          scrollHint.classList.add('is-hidden');
        }
      }, 8000);
    });
  };
  
  // Initialize on DOMContentLoaded and Shopify section load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChalkboardPanorama);
  } else {
    initChalkboardPanorama();
  }
  
  document.addEventListener('shopify:section:load', initChalkboardPanorama);
})();
